var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7 74.2C38.3 67.9 43.4 55.9 48.7 54.6C54 53.3 53.2 56.9 59.7 57.8C66.2 58.7 69.9 52.7 69.9 52.7C69.9 52.7 76.3 49.5 82.6 62.4C88.9 75.3 79.4 76.3 74.4 78.9C69.4 81.5 37.2 80.5 37.7 74.2Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4 45.8C55.2 49.5 59.6 49.4 63 48.6C64.8077 48.2412 66.5574 47.6355 68.2 46.8C69.8528 45.9729 71.3433 44.8551 72.6 43.5C71.5844 45.1171 70.2171 46.4843 68.6 47.5C64.2 50 55.4 52.1 53.4 45.8V45.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 29.7C55.7283 32.3835 54.8517 34.9798 53.6 37.4C53.5276 34.6064 54.4489 31.8778 56.2 29.7V29.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 41.3C59 41.4 61.4 42.1 62.9 41.8L63.8 41.4001L63.5 42.4001C63.3254 42.9526 63.0357 43.4619 62.6499 43.8943C62.2641 44.3267 61.791 44.6724 61.2619 44.9087C60.7327 45.1449 60.1595 45.2663 59.58 45.2648C59.0005 45.2633 58.4279 45.139 57.9 44.9001C59.8 44.9001 61.9 44 62.5 42.1L63.2 42.7001C61.2 43.1001 59.2 42.2 57.5 41.3V41.3Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 42.3C54.8326 42.3602 55.5462 42.5641 56.2 42.9C56.5 42.9 56.8 43.3 56.9 43.6C56.9293 43.8263 56.8985 44.0563 56.8108 44.267C56.723 44.4776 56.5813 44.6614 56.4 44.8C56.2604 44.8703 56.1063 44.9069 55.95 44.9069C55.7937 44.9069 55.6396 44.8703 55.5 44.8H55.6L54.2 44.4C53.6 44.1 53.1 43.9 52.9 43.2L53.1 43.5C50.5 42.4 50.2 39.7 53 38.6C52.6705 38.9415 52.3695 39.3094 52.1 39.7C51.1 41.1 52.4 42.2 53.8 42.7C55.2 43.2 55.1 43.7 55.8 44C56.5 44.3 55.9 44.1 56 44H56.2C56.2086 43.8957 56.1842 43.7914 56.1304 43.7017C56.0766 43.612 55.996 43.5415 55.9 43.5C55.3 43.2 54.6 42.6 54.1 42.4V42.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74 38.4C70.7 37.9 70 34.8 71.3 32.1L71.8 32.3C71.0999 33.2578 70.0878 33.9416 68.9379 34.2337C67.788 34.5257 66.5723 34.4077 65.5 33.9C64.3693 33.4715 63.4322 32.6478 62.8622 31.5814C62.2923 30.515 62.1281 29.2782 62.4 28.1L63 28.7C61.9123 29.1713 60.719 29.3455 59.5419 29.205C58.3649 29.0645 57.2462 28.6141 56.3 27.9C53.2 25.8 53.5 21 56.3 18.8C59.1 16.6 63 17.8 66 19.2H65.7C64.9 15.5 67.1 11.7 71.3 12.1C72.4882 12.1947 73.6285 12.6093 74.6 13.3H74.1C78.4 7.3 84.8 7.6 88.2 14.2C89.6 17.5 88.4 22.1 85 23.7V22.7C89 24 92.3 27.4 90.5 31.8C89.4 34.4 87.4 37 84.5 37.7C83.5369 37.8696 82.5491 37.8355 81.6 37.6H81.8C81.3059 38.8501 80.7036 40.0547 80 41.2H79.9C80.5341 40.0821 81.0694 38.911 81.5 37.7H81.7C85.6 38.5 88.5 35.2 89.8 31.9C91.1 28.6 87 24.6 83.1 23.6L84.7 23.1C85.1452 22.9627 85.5322 22.6813 85.8 22.3C89.3 18.5 87.6 12.9 83.2 10.8C78.8 8.7 76.6 11.5 74.7 14.1L74.4 14.4C71.9 12.1 67.1 12.4 66.2 16.2C65.8665 17.3728 65.8321 18.6105 66.1 19.8L65.8 19.6C62.2 17.8 56.3 17.1 55 22C53.7 26.9 59.1 29.9 63.4 27.8C63.0193 29.0172 63.0903 30.3309 63.6 31.5C65 34.2 69.4 34.8 71.3 32.2L72.8 30.4C71.8 32.5 69.9 35.8 72.3 37.7C72.8145 38.0658 73.3902 38.3367 74 38.5V38.4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8 43C78.4 45.7 74.6 47.2 73.3 44.2C73.1017 43.6229 73.0256 43.0109 73.0765 42.4029C73.1274 41.7948 73.3043 41.204 73.5958 40.6679C73.8874 40.1319 74.2872 39.6623 74.77 39.2891C75.2527 38.9159 75.8078 38.6472 76.4 38.5H76.3C80.2 28.6 76.7 23.8 67.6 20C78.1 22.1 81.4 29.3 76.6 38.7C74.3 38.9 73.3 41.9 74.1 43.7C74.1571 43.9414 74.2635 44.1684 74.4125 44.3668C74.5615 44.5651 74.7499 44.7305 74.9659 44.8526C75.1819 44.9746 75.4208 45.0508 75.6675 45.0761C75.9143 45.1015 76.1637 45.0756 76.4 45C76.9006 44.8434 77.3634 44.5849 77.7593 44.2407C78.1551 43.8965 78.4754 43.4741 78.7 43H78.8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 80.1C42.2 80.1 47.9 92.7 56.2999 87.2C68.1999 79.4 70.0999 90.4 70.0999 90.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 72.1C10 62.1 6.00003 45.7 12.9 40.5C23.1 32.8 27.1 45 26.5 47.5C25.9 50 22.3 51.5 20.9 52C19.5 52.5 21.7 62 26.3 67.2C30.9 72.4 32.7 74.4 33.7 74.4C34.7 74.4 37.9 70.3 39.7 70.2C42.4729 70.7286 45.0192 72.0889 47 74.1C49.6 76.8 49.3 82.1 46.1 84.2C39.3 88.7 31.1 85.9 18.4 72.1Z",
    fill: "#5A87FF",
    stroke: "#5A87FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 37.2L31.5 39.5",
    stroke: "#FF931E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 21.5L25.9 30.6",
    stroke: "#FF931E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 29.8L29 34.9001",
    stroke: "#FF931E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 49.5C57.5 49.5 60.3 53.6 56.2 56",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.5f5fc75ea5980622ed173b3e763aaea2.svg";
export { ForwardRef as ReactComponent };